var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-booking-grid',{attrs:{"bookings":_vm.bookings,"search-key":_vm.searchQuery,"season":_vm.season,"totals":_vm.totals}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }